// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__32UHL","overflowing":"ReadFullNote_overflowing__RQBJs"};